import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { P404Component } from './404.component';
import { P500Component } from './500.component';
import { LoginComponent } from './login.component';
import { RegisterComponent } from './register.component';

import { PagesRoutingModule } from './pages-routing.module';
import { LaddaModule } from 'angular2-ladda';
import { FormsModule }   from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';

@NgModule({
  imports: [
    PagesRoutingModule,
    CommonModule,
    FormsModule,
    ReCaptchaModule,
    LaddaModule.forRoot({
            style: "expand-right"
        })
  ],
  declarations: [
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts